import { Injectable } from '@angular/core';
import { ProjectInfo } from '@frontend-site/shared/data';
import { PermissionsService } from '@frontend-site/shared/core';
import { MenuItem } from '../../../models';
import { MENU_IDS } from '../../menu-ids';

@Injectable()
export class TestsMenuFactory {
    constructor(private readonly permissionsService: PermissionsService) {}

    create(projectInfo: ProjectInfo): MenuItem | null {
        if (projectInfo.isIcr3Project()) {
            return null;
        }
        if (projectInfo.isRestrictedApp()) {
            return null;
        }
        if (projectInfo.modular && !projectInfo.hasTestsModule()) {
            return null;
        }

        const menu: MenuItem[] = [
            {
                id: MENU_IDS.PROJECT.TESTS.TEST_TREE,
                label: 'Enumerations.ApplicationModules.TEST_TREE',
                routePath: `/${projectInfo.id}/tests/tree`
            },
            {
                id: MENU_IDS.PROJECT.TESTS.TEST_LIST,
                label: 'Enumerations.ApplicationModules.TEST_LIST',
                routePath: `/${projectInfo.id}/tests/list`
            },
            {
                id: MENU_IDS.PROJECT.TESTS.STEP_LIST,
                label: projectInfo.testAutomationStandalone
                    ? 'Enumerations.ApplicationModules.PLANNED_RUN_LIST'
                    : 'Enumerations.ApplicationModules.STEP_LIST',
                routePath: `${projectInfo.id}/steps/list`
            }
        ];

        if (projectInfo.testAutomation) {
            menu.push({
                id: MENU_IDS.PROJECT.TESTS.PLAYLIST_EXECUTION,
                label: 'Execution.NavBar.playlistExecutionMonitor',
                routePath: `/tm/${projectInfo.id}/execution/playlistExecutionMonitor`
            });
        }

        if (projectInfo.locotaEnabled) {
            let subMenu: MenuItem[] = [];

            subMenu.push({
                id: MENU_IDS.PROJECT.TESTS.PA_EXECUTION_LIST,
                label: 'Enumerations.ApplicationModules.PA_EXECUTION_LIST_MENU',
                routePath: `${projectInfo.id}/paExecution/list`
            });

            subMenu.push({
                id: MENU_IDS.PROJECT.TESTS.PA_RUN,
                label: 'Enumerations.ApplicationModules.PA_RUN_LIST_MENU',
                routePath: `${projectInfo.id}/paRun/list`
            });

            subMenu.push({
                id: MENU_IDS.PROJECT.TESTS.TEST_SET_LIST,
                label: 'Enumerations.ApplicationModules.TEST_SET_LIST',
                routePath: `${projectInfo.id}/testSets/list`
            });

            subMenu.push({
                id: MENU_IDS.PROJECT.TESTS.PA_EXECUTION_SCHEDULING,
                label: 'Enumerations.ApplicationModules.PA_EXECUTION_SCHEDULING_LIST',
                routePath: `${projectInfo.id}/paExecutionScheduling/list`
            });

            if (!projectInfo.isS4GreenProject()) {
                menu.push({
                    id: MENU_IDS.PROJECT.TESTS.AUTOMATION_SUB,
                    label: 'Enumerations.ApplicationModules.AUTOMATION_SUB',
                    menu: subMenu,
                    routePath: 'fakeRoute'
                });
            }
        }

        if (this.permissionsService.hasPermissions('Test Box : upload', [projectInfo.id]) && !projectInfo.testAutomationStandalone) {
            menu.push({
                id: MENU_IDS.PROJECT.TESTS.TEST_BOX,
                label: 'Enumerations.ApplicationModules.TEST_BOX',
                routePath: `/${projectInfo.id}/tests/testbox`
            });
        }

        return {
            id: MENU_IDS.PROJECT.TESTS.DEFAULT,
            label: 'Enumerations.ApplicationModules.EXECUTION',
            routePath: `${projectInfo.id}/tests/tree`,
            menu
        };
    }
}
